import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import {
  attendeeNetworkHealth,
  attendeeReceivedFrame,
  sessionState,
  brandingSettings,
  sourceUpdateStatus,
  readinessCheck,
  userBackground,
  videoDeviceLost,
  audioInputDevice,
  audioOutputDevice,
  showReadinessCheck,
  sandboxMeetingStatus,
  sandboxMeetingSession,
  transformedVideoInputs,
  attendeeVoiceIntensity,
  broadcast,
  user,
  attendeePresence,
  attendeeCameraStatus,
  sources as broadcastSources,
  liveSources,
  videoInputDevice
} from '@shoflo/studio-redux/reducers';

//User reducers
import features from './features';
import isLoggedOut from './isLoggedOut';
import screenShareRequest from './screenShareRequest';

//Event reducers
import { event } from '@shoflo/studio-redux/reducers/event';
import eventCrew from './eventCrew';

//Team reducers
import { team } from '@shoflo/studio-redux/reducers/team';

//Modal reducer
import modal from './modal';

import meeting from './meeting';
import attendeeRoster from './attendeeRoster';
import program from './program';
import limitedBroadcast from './broadcast';
import knock from './knock';
import isAudioMuted from './isAudioMuted';
import isVideoActive from './isVideoActive';
import isScreenShareActive from './isScreenShareActive';
import mediaPlayerSettings from './mediaPlayerSettings';
import directorControls from './directorControls';
import directorRequest from './directorRequest';
import directorRequestMessages from './directorRequestMessages';
import isPresenterDismissed from './isPresenterDismissed';
import muteMeetingAudio from './muteMeetingAudio';
import serverTimeDelta from './serverTimeDelta';
import startProgram from './startProgram';
import settings from './settings';
// remove with studio.requirePresenterAuth
import presenterId from './presenterId/presenterId';
import validateBroadcast from './validateBroadcast';
import notification from './notification';
import realtimeSocketConnected from './realtimeSocketConnected';
import knockFailed from './knockFailed';
import { streamStatus } from './stream';

import { shouldHaveFeature } from '@studio/feature.flags';

const requirePresenterAuth = shouldHaveFeature('studio.requirePresenterAuth');

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    modal,
    features,
    user,
    event,
    eventCrew,
    team,
    isLoggedOut,
    meeting,
    attendeeRoster,
    knock,
    audioInputDevice,
    audioOutputDevice,
    videoInputDevice,
    broadcastSources,
    program,
    isAudioMuted,
    isVideoActive,
    isScreenShareActive,
    mediaPlayerSettings,
    broadcast: requirePresenterAuth ? broadcast : limitedBroadcast,
    brandingSettings,
    attendeeCameraStatus,
    directorControls,
    directorRequest,
    directorRequestMessages,
    isPresenterDismissed,
    attendeePresence,
    muteMeetingAudio,
    serverTimeDelta,
    startProgram,
    attendeeNetworkHealth,
    attendeeReceivedFrame,
    settings,
    sandboxMeetingSession,
    readinessCheck,
    streamStatus,
    presenterId,
    sandboxMeetingStatus,
    validateBroadcast,
    notification,
    realtimeSocketConnected,
    knockFailed,
    sessionState,
    showReadinessCheck,
    sourceUpdateStatus,
    videoDeviceLost,
    userBackground,
    transformedVideoInputs,
    attendeeVoiceIntensity,
    liveSources,
    screenShareRequest
  });

export default rootReducer;
